// Баннер аварийной паузы приёма деклараций.
// Состояние берём с сервера (/api/system/status/), чтобы включать и выключать
// паузу без пересборки фронтенда.
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useIrsStatus } from '../hooks/useIrsStatus';

export default function IrsStatusBanner() {
  const { paused, message } = useIrsStatus();

  if (!paused) return null;

  return (
    <div className="w-full bg-amber-100 border-b-4 border-amber-500">
      <div className="max-w-6xl mx-auto px-4 py-4 flex items-start gap-3 text-amber-950">
        <AlertTriangle className="w-6 h-6 flex-shrink-0 text-amber-700 mt-0.5" aria-hidden="true" />
        <div>
          <p className="font-bold text-base sm:text-lg leading-snug">
            IRS systems are being updated — we are accepting filings as usual
          </p>
          <p className="mt-1 text-sm sm:text-base text-amber-900">{message}</p>
          <p className="mt-1 text-xs sm:text-sm text-amber-800">
            Questions? Contact{' '}
            <a href="mailto:support@2290pay.org" className="underline">
              support@2290pay.org
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
}
